<template>
  <md-button
    :disabled="disabled"
    v-if="isVisible"
    :class="buttonClass"
    @click="action"
  >
    <md-tooltip>{{ type }}</md-tooltip>
    <md-icon>{{ buttonIcon }}</md-icon>
  </md-button>
</template>

<script>
export default {
  name: "state-button",
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: undefined
    },
    stateId: {
      type: Number,
      default: undefined,
      validator: function(value) {
        return [1, 2, 3].indexOf(value) !== -1;
      }
    },
    type: {
      type: String,
      default: undefined,
      validator: function(value) {
        return ["Archive", "Delete", "Reactivate"].indexOf(value) !== -1;
      }
    },
    canDelete: {
      type: Boolean,
      default: undefined
    },
    canRestore: {
      type: Boolean,
      default: undefined
    },
    managerOnly: {
      type: Boolean,
      default: false
    },
    role: {
      type: Number,
      default: undefined,
      validator: function(value) {
        return [4].indexOf(value) !== -1;
      }
    }
  },
  computed: {
    isVisible() {
      if (this.$auth.isInRole(this.role)) {
        switch (this.type) {
          case "Archive": {
            if (this.stateId === 1 && !this.canDelete) return true;
            break;
          }
          case "Delete": {
            if (this.stateId === 1 && this.canDelete) return true;
            break;
          }
          case "Reactivate": {
            if (
              (this.stateId === 3 ||
                (this.stateId === 2 && this.$auth.isInRole(4))) &&
              this.canRestore
            )
              return true;
            break;
          }
        }
        return false;
      }
      if (this.$auth.isInGlobalRole()) {
        switch (this.type) {
          case "Archive": {
            if (this.stateId === 1 && !this.canDelete && !this.managerOnly)
              return true;
            break;
          }
          case "Delete": {
            if (this.stateId === 1 && this.canDelete && !this.managerOnly)
              return true;
            break;
          }
          case "Reactivate": {
            if (this.stateId === 3 && this.canRestore) return true;
            break;
          }
        }
        return false;
      }

      return false;
    },
    buttonClass() {
      switch (this.type) {
        case "Archive":
          return "md-just-icon md-warning";
        case "Delete":
          return "md-just-icon md-danger";
        case "Reactivate":
          return "md-just-icon md-success";
      }
      return "";
    },
    buttonIcon() {
      switch (this.type) {
        case "Archive":
          return "assignment_returned";
        case "Delete":
          return "delete";
        case "Reactivate":
          return "restore_from_trash";
      }
      return "";
    }
  },
  methods: {
    action() {
      this.$emit("state-click");
    }
  }
};
</script>

<style>
.add-button {
  float: right;
  margin-top: 10px !important;
}
</style>
